/* eslint-disable @next/next/no-img-element */
import {useEffect, useState} from "react";
import http from "../../../utilities/http";
import { isEmpty } from "lodash";
import ImageComponent from "components/cong-dong/imageComponent";

export default function Index({albums, profession}) {

    const [albumsPage, setAlbumsPage] = useState(albums?.meta?.pagination?.current_page);
    const [albumsG, setAlbumsG] = useState(albums);
    const genMoreAlbums = () => {
        if (albumsG?.meta?.pagination?.current_page < albumsG?.meta?.pagination?.total_pages) {
            return (
                <div className="">
                    <a className="btn btn--blue-light w-100" onClick={() => setAlbumsPage(albumsPage + 1)}>
                        Xem thêm
                    </a>
                </div>
            );
        }
    };
    const fetchData = async () => {
        try {
            let url = `community/professional/${profession.id}/albums?page=${albumsPage}&per_page=12`;
            const response = await http(url, {}, {token: 'default'}, 'v2');
            response.data = albumsG?.data.concat(response?.data);
            setAlbumsG(response);
        } catch (e) {
            console.log(e.message);
        }
    };
    useEffect(() => {
        if ( albumsPage !== albumsG?.meta?.pagination?.current_page){
            fetchData();
        }
    }, [albumsPage]);
    return (
        <>
            <div className="gallery__featured lstPhoto">
                {
                    !isEmpty(albumsG?.data) &&
                    <ul className="">
                        {albumsG?.data?.map((photo, index) => {
                            return (
                                <ImageComponent key={photo.slug + index} item={photo} index={index} slug={'album'}/>
                            );
                        })}
                    </ul>
                }

            </div>
            {genMoreAlbums()}
            {
                isEmpty(albumsG?.data) && <div className="expert__wrap-content expert-voucher">
                    <div className="voucher-none">
                        <div className="thumb"><img src="/images/icon-no-data.svg" alt="" /></div>
                        <p className="text">Chưa có hình ảnh nào</p>
                    </div>
                </div>
            }
        </>
    );
}